import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { H3, H4, H6, P, Image, Btn } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import {
  MyProfile,
  Bio,
  Password,
  Website,
  Save,
  EmailAddress,
  EditProfile,
  Name,
} from "../../../../Constant";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
import { Button } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { UserOutlined } from "@ant-design/icons";
import { fetchUserDetails } from "../../../../api/user.api";

const MyProfileEdit = () => {
  const [details, setDetails] = useState({});
  const { userDetails, setUserDetails } = useAPIUser();
  const avatarInputRef = React.useRef(null);
  const signatureInputRef = React.useRef(null);

  useEffect(() => {
    getUserDetails();
  }, [userDetails]);

  const getUserDetails = () => {
    fetchUserDetails().then((res) => {
      setDetails(res);
    });
  };

  const uploadAvatar = (e) => {
    const image = e.target.files[0];
    const formData = new FormData();
    formData.append("avatar", image);
    const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
    axios
      .put(`apiV1/user/${details.id}/`, formData, config)
      .then((res) => {
        toast.success("Avatar uploaded successfully");
        getUserDetails();
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };

  const uploadSignature = (e) => {
    const image = e.target.files[0];
    const formData = new FormData();
    formData.append("signature", image);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .put(`apiV1/user/${details.id}/`, formData, config)
      .then((res) => {
        toast.success("Signature uploaded successfully");
        getUserDetails();
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };

  return (
    <Fragment>
      <Card>
        <CardHeader className="pb-0">
          <H4 attrH4={{ className: "card-title mb-0" }}>{MyProfile}</H4>
        </CardHeader>
        <CardBody>
          <Row className="mb-2">
            <div
              className="mx-auto d-block"
              style={{
                textAlign: "center",
              }}
            >
              <div>
                <input
                  type="file"
                  ref={avatarInputRef}
                  style={{ width: "0px", height: "0px", opacity: "0", zIndex: "-1" }}
                  onChange={(e) => {
                    uploadAvatar(e);
                  }}
                  accept="image/jpg,image/png,image/jpeg"
                />
                {details?.avatar ? (
                  <Image
                    className=""
                    attrImage={{
                      className: "img-100 rounded-circle mx-auto d-block",
                      alt: "",
                      src: `${details?.avatar}`,
                      onClick: () => {
                        avatarInputRef.current.click();
                      },
                      style: {
                        cursor: "pointer",
                      }
                    }}
                  />
                ) : (
                  <div
                    className="img-100 rounded-circle mx-auto"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #000",
                    }}
                  >
                    <UserOutlined style={{ fontSize: "60px" }} />
                  </div>
                )}
              </div>
              <div className="media-body py-3">
                <H3 attrH3={{ className: "mb-1 f-20 txt-primary" }}>
                  {details?.name}
                </H3>
                <P>{details?.designation}</P>
              </div>
              <div className="py-2">
                <input
                  type="file"
                  ref={signatureInputRef}
                  style={{ width: "0px", height: "0px", opacity: "0", zIndex: "-1" }}
                  onChange={(e) => {
                    uploadSignature(e);
                  }}
                  accept="image/jpg,image/png,image/jpeg"
                />
                {details?.signature ? (
                  <Image
                    className=""
                    attrImage={{
                      className: "mx-auto d-block",
                      alt: "",
                      src: `${details?.signature}`,
                      style: {
                        width: "200px",
                        height: "70px",
                        cursor: "pointer",
                        objectFit: "contain",
                      },
                      onClick: () => {
                        signatureInputRef.current.click();
                      }
                    }}
                  />
                ) : (
                  <div
                    className="mx-auto"
                    style={{
                      width: 200,
                      height: 70,
                      border: "1px solid #888",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => {
                      signatureInputRef.current.click();
                    }}
                  >
                    Signature will show up here
                  </div>
                )}
                <p>
                  Signature
                </p>
              </div>
            </div>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default MyProfileEdit;
